import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const imgSrc = (url) => `${process.env.REACT_APP_BACKEND_URL}${url}`;

export default function Admissions() {
  const [adm, setAdm] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API}/admissions`)
      .then((r) => r.json())
      .then(setAdm)
      .catch(() => setAdm({ show_poster: false, poster_url: null }));
  }, []);

  const showPoster = Boolean(adm?.show_poster && adm?.poster_url);

  const goContact = () => {
    navigate("/");
    setTimeout(() => {
      if (window.__lenis) window.__lenis.scrollTo("#contact", { duration: 1.6 });
      else
        document
          .getElementById("contact")
          ?.scrollIntoView({ behavior: "smooth" });
    }, 700);
  };

  return (
    <main className="relative">
      <Navbar />
      <PageHero
        eyebrow="Val-Hue High School & Junior College"
        title="Admissions"
        titleTestId="admissions-title"
        heroTestId="admissions-hero"
      />

      <section className="relative" data-testid="admissions-status-section">
        <div className="mx-auto flex max-w-4xl flex-col items-center px-6 py-24 text-center md:py-32">
          {!adm ? (
            <p className="text-sm text-[#143A66]/60">Loading…</p>
          ) : showPoster ? (
            <Reveal className="flex flex-col items-center">
              <img
                src={imgSrc(adm.poster_url)}
                alt="Admissions poster"
                data-testid="admissions-poster"
                className="max-h-[70vh] w-auto max-w-full rounded-2xl object-contain shadow-[0_36px_70px_-28px_rgba(10,38,71,0.45)] ring-1 ring-[#143A66]/15"
              />
              <button
                type="button"
                onClick={goContact}
                data-testid="admissions-enquire-button"
                className="group mt-10 inline-flex items-center gap-2 rounded-full bg-[#F47221] px-7 py-3 text-sm font-semibold text-white transition-opacity hover:opacity-90"
              >
                Enquire Now
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </Reveal>
          ) : (
            <Reveal>
              <p
                data-testid="admissions-closed-text"
                className="font-display text-2xl font-semibold leading-relaxed text-[#143A66] md:text-3xl"
              >
                Admissions for the next academic year will open soon — check
                back here for updates.
              </p>
            </Reveal>
          )}
        </div>
      </section>

      <Footer />
    </main>
  );
}
